<template>
    <div>
      <GridLayout v-if="widgetsFormatted?.length > 0"
          v-model:layout="widgetsFormatted"
          @layout-updated="layoutUpdated"
          :margin="[3, 10]"
          :col-num="2"
          :row-height="30"
          :auto-size="true"
          is-draggable
          is-resizable>
        <template #item="{ item }">
          <WidgetStat :widget="item" :start="start" :end="end" />
        </template> 
      </GridLayout>
    </div>
</template>
<script setup>
import {GridLayout} from 'grid-layout-plus';
import { useStore } from 'vuex'
import WidgetStat from './WidgetStat.vue'
import { computed, reactive } from 'vue'

const store = useStore()

const props = defineProps({
  start: { type: Date, required: false },
  end: { type: Date, required: false },
})

const addedWidgets = computed(() => store.getters['stats/getAddedWidgets'])
const widgetsFormatted = computed(() => addedWidgets.value.map(widget => ({ id: widget.id, i: widget.user_widget_id, x: widget.column, y: widget.row, w: widget.weight, h: widget.height, type: widget.type, minW: 1, minH:widget?.type.minH  })))


const layoutUpdated = (data) =>{
 
  const payload = data.map(widget => ({  
    id: widget.i,
    row: widget.y,
    column: widget.x,
    weight: widget.w,
    height: widget.h
  }))

  if(payload?.length > 0){
    store.dispatch('stats/updateUserWidget', {widgets: payload})
        .then((response) => {
          loadUserWidgets()
        })
        .catch((err) => {

        })
        .finally(() => {

        })
  }
}

</script>

<style scoped>
.vgl-layout {
  background-color: transparent;
}

:deep(.vgl-item:not(.vgl-item--placeholder)) {
}

:deep(.vgl-item--resizing) {
  opacity: 90%;
}

:deep(.vgl-item--static) {
  background-color: #cce;
}

.text {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: auto;
  font-size: 24px;
  text-align: center;
}

.layout-json {
  padding: 10px;
  margin-top: 10px;
  background-color: #ddd;
  border: 1px solid black;
}

</style>